import React from 'react';
import cn from 'classnames';

import { SEARCH_IMGS_NOT_LAZY_LOADED } from 'constants/appConstants';
import { LazyImage } from 'components/common/Image';

import css from 'styles/components/common/card/cardMedia.scss';

const CardMedia = ({ imageIndex, isHovered, mainImage, hoverImage, children }) => (
  <div className={cn(css.imageWrapper, { [css.hovered]: isHovered && hoverImage?.src })}>
    {children}
    <figure>
      <meta itemProp="image" content={mainImage.src} />
      <LazyImage
        forceLoad={imageIndex < SEARCH_IMGS_NOT_LAZY_LOADED}
        className={css.mainImage}
        {...mainImage}/>
      {hoverImage && <LazyImage
        forceLoad={imageIndex < SEARCH_IMGS_NOT_LAZY_LOADED}
        className={css.hoverImage}
        {...hoverImage}/>}
    </figure>
  </div>
);

export default CardMedia;
